import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";

import * as actionTypes from "./actions/actionTypes";
import authReducer from "./reducers/auth";
import darsReducer from "./reducers/dars";
import divisionsReducer from "./reducers/divisions";
import propertiesReducer from "./reducers/properties";
import subscriptionReducer from "./reducers/subscriptions";
import globalAppReducer from "./reducers/app";
import mapFilterReducer from "./reducers/mapFilter";
import shiftsReducer from "./reducers/shifts";
import templatesReducer from "./reducers/templates";
import postOrdersReducer from "./features/postOrders";
import serviceProviderReducer from "./features/serviceProvider";
import usersTableReducer from "./features/usersTable";
import usersReducer from "./features/users";
import propertiesTableReducer from "./features/propertiesTable";
import clientReducer from "../store/features/clients/slice";

const appReducer = combineReducers({
  auth: authReducer,
  dars: darsReducer,
  divisions: divisionsReducer,
  properties: propertiesReducer,
  users: usersReducer,
  subscriptions: subscriptionReducer,
  app: globalAppReducer,
  mapFilter: mapFilterReducer,
  shifts: shiftsReducer,
  templates: templatesReducer,
  postOrders: postOrdersReducer,
  serviceProvider: serviceProviderReducer,
  usersTable: usersTableReducer,
  propertiesTable: propertiesTableReducer,
  clients: clientReducer,
});

const rootReducer = (state, action) => {
  if (action.type === actionTypes.app.RESET) {
    return appReducer(undefined, action);
  } else {
    return appReducer(state, action);
  }
};

const store = configureStore({ reducer: rootReducer });

export default store;
